import { graphql } from 'gatsby';
import React from 'react';
import Container from '../../primitives/grid/container';
import RichTextEditorStyles from '../../utils/rich-text-editor-styles';
import paddingDefault from '../../utils/padding-default';

// We could get the 'content' field here instead of textContent, if it's coming from ContentStack Live Preview

const RichtextBlock: React.FC<Queries.RichtextBlockDataFragment & { content?: string }> = (data) => {
    const { textContent, content } = data;
    return (
        <section>
            <Container css={[paddingDefault()]}>
                <div
                    css={RichTextEditorStyles}
                    /* eslint-disable-next-line react/no-danger */
                    dangerouslySetInnerHTML={{ __html: textContent || content || '' }}
                />
            </Container>
        </section>
    );
};

export const query = graphql`
  fragment RichtextBlockData on CsRichtextBlock {
    ... on CsRichtextBlock {
      textContent: content
    }
  }
`;

export default RichtextBlock;
